/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import styles from './styles';

interface PropTypes {
  className?: string;
  noUnderline?: boolean;
}

const InlineButton: React.FC<
  PropTypes & JSX.IntrinsicElements['button']
> = props => {
  const { children, noUnderline, onClick, className, ...rest } = props;
  return (
    <button
      onClick={onClick}
      css={noUnderline ? styles.noUnderline : styles.underline}
      className={className}
      {...rest}
    >
      {children}
    </button>
  );
};

export default InlineButton;
